import React, {useState} from "react";
import {PATH} from "../../../../config";
import {Button, Modal, message} from "antd";
import CountdownTimer from "../timer/CountDowntimer";
import axiosData from "../../../../helpers/axiosData";
import { toast } from "react-toastify";
import {redirectTo} from "../../../../config/CoreMethods";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../redux/features/userSlice";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../config/constants";

const Details = ({data}) => {

    let deadline = "Jul, 28, 2024, 10:33";
    let free = true;

    const [messageApi, contextHolder] = message.useMessage();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const handleOk = () => { setIsModalVisible(false);}
    const handleCancel = () => { setIsModalVisible(false); };

    const buyTicket = (event_id) => {
        axiosData.post("/api/_web3/event/buy-ticket/" + event_id).then((res) => {
            
            console.log('res.data', res.data)

            if (res.data.success) {
                // toast.success('Successfullly buyed')
                messageApi.open({
                    type: 'success',
                    content: 'Successfullly buyed',
                });

            } else {
                // toast.error(res.data.message)
                messageApi.open({
                    type: 'error',
                    content: res.data.message,
                });
            }
        }).catch(er => {
            toast.error('OOPS! Something went wrong.')
        })
    }

    let GetUser = useSelector(selectUser);


    return (
        <div className="font-mont edets">
            {contextHolder}
            <Modal footer={false} closable={false} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} className="modal modal-logo" style={{background: `#1c1a42 url(${PATH+'logo-icon-gray.svg'}) no-repeat center center / 140%`}}>
                <div className="text-center">
                    <h3 className="font-normal text-lg text-white mb-9">You want to buy a ticket for the <strong>“{data.name}”</strong> event</h3>
                    <div className="flex items-center justify-center gap-x-3 mb-3">
                        <img src={PATH + data.ticket_type + '.svg'} alt="" width="32px"/>
                        <span className="font-bold text-xl text-white uppercase">{data.ticket_value} {data.ticket_type}</span>
                    </div>
                    
                {GetUser && data.ticket_type && GetUser[data.ticket_type+'_balance'] && parseInt(GetUser[data.ticket_type+'_balance']) > parseInt(data.ticket_value) ?
                    <p className="font-normal text-sm text-green-500">The displayed amount will be deducted from your wallet</p>
                : 
                    <p className="font-normal text-sm text-red">The displayed amount is not in your wallet</p>
                }

                </div>

                {GetUser && data.ticket_type && GetUser[data.ticket_type+'_balance'] && parseInt(GetUser[data.ticket_type+'_balance']) > parseInt(data.ticket_value) ?
                    <div className="flex items-center justify-center gap-x-4 mt-12">
                        <Button onClick={() => handleCancel()} className="min-w-24 border-0 bg-gray-200 text-indigo-900 hover:bg-gray-300 rounded-2xl font-large">No, cancel</Button>
                        <Button onClick={() => buyTicket(data.id)} className="min-w-24 border-0 bg-pink-300 text-white hover:bg-pink-400 rounded-2xl font-large">Yes, I want to pay</Button>
                    </div>
                :
                    <div className="flex items-center justify-center gap-x-4 mt-12">
                        <Button onClick={() => handleCancel()} className="min-w-24 border-0 bg-gray-200 text-indigo-900 hover:bg-gray-300 rounded-2xl font-large">cancel</Button>
                        <Link to={ROUTES.wallet.path} > 
                            <Button onClick={() => buyTicket(data.id)} className="min-w-24 border-0 bg-pink-300 text-white hover:bg-pink-400 rounded-2xl font-large">Go to the wallet</Button>
                        </Link>
                    </div>
                }

            </Modal>
            <div className="edets-card">
                <h4 className="edets_ttl">Ticket</h4>
                <div className="edets-card_body">
                    <div className="edets-token">
                        {free ? <span className="edets-token_free uppercase">Free</span> :
                            <>
                                <img src={PATH + data.ticket_type + '.svg'} alt=""/>
                                <span className="edets-token_amount uppercase">{data.ticket_value} {data.ticket_type}</span>
                            </>
                        }

                    </div>
                    {free ? <p className="edets-desc">You can directly enter the events for free without purchasing a ticket</p> :
                        <p className="edets-desc">The amount to be paid to obtain the right to participate in the event</p>
                    }
                    {data.is_buyed ?
                        <Button type="primary" disabled="disable" className="einfo-btn btn-disable">BUYED</Button>
                    :
                    <Button className={`submit-btn ${free ? 'border-0 bg-indigo-600 text-white opacity-50 cursor-not-allowed' : ''}`} disabled={free ? 'disable' : ''} onClick={() => setIsModalVisible(true)}>Get Ticket</Button>
                }
                {/* <Button onClick={() => buyTicket(data.id)} className="submit-btn">Get Ticket</Button> */}
                </div>
            </div>
            <div className="edets-card">
                {data.reward_value?
                    <h4 className="edets_ttl">REWARD POOL</h4>
                :''}
                <div className="edets-card_body">
                    {data.reward_value?
                    <div className="edets-token">
                        <img src={PATH + data.reward_type + '.svg'} alt=""/>
                        <span className="edets-token_amount uppercase">{data.reward_value} {data.reward_type}</span>
                    </div>
                    :''}

                    <p className="edets-desc">The prize fund will be divided equally among the participants of the event</p>
                    <div className="edets-note"><span className="evisit">{data.participants}/{data.participant_count}</span> Number of participants</div>
                    <div className="eremain">
                        {data.status === 'end' ?

                        <p className="eremain-status eremain-finished">Finished</p>
                        : data.status === 'live' ?
                            <p className="eremain-status eremain-live">Live</p>
                        :
                        <>
                        <div className="countdown">
                            <CountdownTimer targetDate={data.deadline} />
                        </div>
                        <p className="eremain-txt">Remaining time until the start of the event</p>
                        </>
                        } 
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Details;